import React from 'react'
import { Box, Container, Typography, Button } from '@mui/material'
import { AboutData } from '../assets/data';
import Footer from "../components/Footer"
import ArrowBtn from '../components/ArrowBtn';
import useMediaQuery from '@mui/material/useMediaQuery';
import aboutimg from "../assets/aboutD.png";
import { Link ,useNavigate} from 'react-router-dom';
const About = () => {

  const matches = useMediaQuery('(max-width:500px)');
  const navigate = useNavigate();

  const handleClick = () => {
  navigate('/', {state:{ fromAboutUs: true} });
  };
  return (
    <>

      <Box className="Hero_main" 
      style={{ backgroundImage:`url(${aboutimg})`, height: matches ? '100vh' : '120vh' }} >
        <Box className="hero_div">
          <h1 className='herotitle'>
            The WeCare
            <br /> Story
          </h1>
          {/* <Link to='/'> */}
            <Button variant="contained" className='herobtn1' onClick={handleClick}>
            WeCare Plans
            </Button>
          {/* </Link> */}
        </Box>
      </Box>
      <Container maxWidth="xl" className='containers'>
        <Box className="about_div">
          {AboutData.map((item, i) => (
            <Box>
              <Typography variant="h3" className='aboutH3'>{item.title}</Typography>
              <Typography variant="body1" className='faq_desc'>{item.desc}</Typography>
            </Box>
          ))}
        </Box>
      </Container>

      <Footer />
    </>
  );
};
export default About;
